import React from "react";

const ArrowRightIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24" fill="none" {...props}>
    <path d="M5.5 12L19.5 12" stroke="#AC764D" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M12.5 5L19.5 12L12.5 19" stroke="#AC764D" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export default ArrowRightIcon;
